import { type SourceType } from "../Designer/types/externallTriggersTypes";
import { type IntegrationStatuses } from "../../../Accounts/Integrations/types";

export enum TagTypes {
  SoftwareApplication = "Software Applications",
  Label = "Labels",
  SkuVersion = "Sku Versions",
}

export enum ReceiveUpdatesTypes {
  None,
  All,
  NotStarted,
}

export type Tags = {
  [key: string]: { type: TagTypes; title: string }[];
};

export type FlowTags = { title: string }[];

export interface Integration {
  id: number;
  type: SourceType | string;
  status: IntegrationStatuses;
}

export type FlowBaseEntity<T> = {
  [entity: string]: T & FlowBaseEntity<T>;
};

export type FlowBasePayload = Tags | Integration[];

export enum FlowBaseEntities {
  Tags = "tags",
  Integrations = "integrations",
}
